<div style="display: flex;justify-content: center;">
    <div class="m-wrapper">
        <span multilang class="m-title ellipsis">Karte</span>
        <span multilang>
            <button mat-dialog-close>
                <img src="../../../../assets/icons/x.svg" alt="">
            </button>
        </span>
    </div>
</div>
<div class="map-wrapper" id="map-wrapper">
    <div id="map" class="map-body">
    </div>
</div>
<div id="details" class="details hide"></div>
<div class="button-cont">
    <button class="det-but" multilang mat-dialog-close>Zurück</button>
    @if(data?.poi[this.selected]){
    <button (click)="angebot()" class="but" multilang>Angebot ab {{ data?.poi[this.selected]?.totalPrice?.value }} €
        p.P.</button>
    }
</div>